<template>
  <div>
    <div v-if="isOpenInvoice || isClosedInvoice">
      <InvoiceStatus :status="data.paymentStatus" />

      <InvoiceValues
        :type="`${isOpenInvoice ? 'open' : 'close'}`"
        :data="data"
      />
    </div>

    <EmptyState
      v-else
      image="employee"
      :imageSize="120"
      class="px-4 content--overflow"
      :style="`height: ${contentHeight}px;`"
    >
      <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
    </EmptyState>
  </div>
</template>

<script>
import { hasRole, calcContentHeight, isObject, isArray, convertToCurrencyBRL } from 'utils/functions'
import InvoiceStatus from 'components/globalDrawer/financial/InvoiceStatus'
import InvoiceValues from 'components/globalDrawer/financial/InvoiceValues'
import EmptyState from 'components/EmptyState'

export default {
  name: 'TabInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    InvoiceStatus,
    InvoiceValues,
    EmptyState
  },
  computed: {
    isClosedInvoice () {
      return this.isValidObject(this.data) &&
        this.data.numericalId &&
        hasRole('billing', 'ROLE_GET_ORDER_SUMMARY')
    },

    isOpenInvoice () {
      return this.isValidObject(this.data) &&
        !this.data.numericalId &&
        hasRole('billing', 'ROLE_GET_ORDER_PREVIEW_SUMMARY')
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.financial.invoices',
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidObject (val) {
      return isObject(val)
    },

    isValidArray (val) {
      return isArray(val)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight() - (65 + 32)
    },

    convertToCurrencyBRL (val) {
      return val ? convertToCurrencyBRL(val).replace('R$ ', '') : 0
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.invoice {
  background-color: $gray-1;

  span {
    display: block;
  }
}

.invoice__divider {
  border-bottom: 1px solid $gray-4;
  margin: 16px 0;
}

.invoice__subtitle {
  font-size: 10px;
  margin-bottom: 16px;
  text-transform: uppercase;
}

.invoice__value {
  font-weight: 600;
  text-align: right;
}

.invoice__value--total {
  font-weight: 600;
  font-size: 16px;
}
</style>
